import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';

interface IProps {
  label: string;
  name: string;
  disabled?: boolean;
  value?: string | null;
  onChange: (date: Date) => void;
}
export default function ViewsDatePicker(props: IProps) {
  const {
    value,
    label,
    disabled,
    onChange,
  } = props;

  const handleChange = (date: Date | null) => {
    if (date) {
      onChange(date);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        views={['year', 'month']}
        label={label}
        disabled={disabled}
        minDate={new Date('2021-01-01')}
        maxDate={new Date()}
        value={value}
        onChange={handleChange}
        renderInput={(params) => <TextField {...params} helperText={null} />}
      />
    </LocalizationProvider>
  );
}
